import LinkRenderer from './LinkRenderer'

export default LinkRenderer
